<template>
  <div class="page page-configurator">
    <div class="page__wrap">
      <div class="page-configurator__access" v-if="!isLogged">
        <div class="page-configurator__access__form">
          <FormKit
            v-model="userData"
            type="form"
            :actions="false"
            @submit="onSubmit"
            id="downloadForm"
          >
            <FormKit
              type="password"
              name="password"
              :label="$t('form.passwordLabel')"
              validation="required"
              :placeholder="$t('form.password')"
            />

            <div class="form-contact__cta">
              <button
                type="submit"
                class="button-round-1 --dark form-contact__submit"
              >
                {{ $t('cta.login') }}
              </button>
            </div>
          </FormKit>
        </div>
      </div>

      <div class="page-configurator__content" v-if="isLogged">
        <button @click="logout" class="m-bottom-24px f-size-14 text-s">
          Logout
        </button>
        <ClientOnly>
          <Configurator />
        </ClientOnly>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue' // Assicurati che ref sia importato se non usi auto-import
import { useCookie } from '#app' // Auto-importato solitamente in Nuxt 3
import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/listing.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

// La nascondo
// showError({ statusCode: 404 })

// --- CONFIGURAZIONE PASSWORD ---
const STATIC_PASSWORD = 'za1234va' // Imposta qui la tua password
const COOKIE_NAME = 'zava_auth_access'
const EXPIRATION_SECONDS = 60 * 60 * 24 * 7 // 1 Settimana (7 giorni)
const authCookie = useCookie(COOKIE_NAME, {
  maxAge: EXPIRATION_SECONDS,
})

// Se il cookie ha il valore "granted", l'utente è loggato
const isLogged = ref(authCookie.value === 'granted')
const userData = ref({})

const { t } = useI18n()

// FormKit passa i dati (data) e il contesto del nodo (node)
const onSubmit = (data, node) => {
  if (data.password === STATIC_PASSWORD) {
    // 1. Password Corretta: Imposta cookie e stato
    authCookie.value = 'granted'
    isLogged.value = true
  } else {
    // 2. Password Errata: Mostra errore sul form
    node.setErrors([t('form')])

    // Reset del campo password (opzionale)
    userData.value.password = ''
  }
}

// Funzione opzionale per resettare (utile per debug o logout)
const logout = () => {
  authCookie.value = null
  isLogged.value = false
  userData.value = {}
}

// Seo
useSeo({
  title: 'Zava Configurator',
  meta: [
    {
      name: 'description',
      content: 'Zava Configurator',
    },
    {
      name: 'robots',
      content: 'noindex',
    },
  ],
})
</script>
